export const availableDiscounts = {
  products: 'products',
  orders: 'orders',
  shipping: 'shipping',
}
